<template>
  <v-tooltip top offset-overflow v-model="show" content-class="tooltip-container">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-h6 text-lg-h5">
        <i
          class="fa-solid fa-circle-question icon-color"
          v-bind="attrs"
          v-on="on"
          @click="show = !show"
        ></i>
      </span>
    </template>
    <span class="tooltip-text">{{ text }}</span>
  </v-tooltip>
</template>
<script>
export default {
  props: ["text"],
  data() {
    return {
      show: false,
    };
  },
};
</script>
<style scoped lang="scss">
.fa-circle-question::before {
  vertical-align: top;
}

@media only screen and (min-width: 1920px) {
  .fa-circle-question::before {
    font-size: 1.25rem;
  }
  .tooltip-text {
    font-size: 1rem;
  }
}
@media only screen and (max-width: 1919px) {
  .fa-circle-question::before {
    font-size: 1rem;
  }
  .tooltip-text {
    font-size: 1rem;
  }
}

@media only screen and (max-width: 960px) {
  .tooltip-container::v-deep {
    max-width: 75% !important;
  }
}

.tooltip-container {
  z-index: 999 !important;
  max-width: 50%;
  background: #202020;
  opacity: 1;
}
.tooltip-text {
  display: block;
  word-wrap: break-word;
  white-space: normal;
}
</style>
